const PATIENTS_ORIGIN = '/patients'

export const CHECKOUT_PROGRAM_ORIGINS = [
  '/programs/my-physicians/',
  '/programs/access-programs/'
]

const startsWithProgramOrigin = (from?: string): boolean =>
  CHECKOUT_PROGRAM_ORIGINS.some((origin) => !!from && from.startsWith(origin))

const isPatientsOrigin = (from?: string): boolean =>
  !!from && (from === PATIENTS_ORIGIN || from.startsWith(`${PATIENTS_ORIGIN}/`))

export const isCheckoutPatientOrigin = (from?: string): boolean =>
  isPatientsOrigin(from) || startsWithProgramOrigin(from)

export const resolveCheckoutReturnPath = (from?: string): string =>
  startsWithProgramOrigin(from) ? (from as string) : PATIENTS_ORIGIN
